import React from "react";
import Hero from "../components/Hero";
import About from "../components/About";
import VisionApproach from "../components/VisionApproach";
import Expertise from "../components/Expertise";
import Services from "../components/Services";
import WhyChooseUs from "../components/WhyChooseUs";
import HowWeWork from "../components/HowWeWork";
import HomeReviews from "../components/HomeReviews";
import TrustedBy from "../components/TrustedBy";
import Contact from "../components/Contact";
import "./Home.css";

const Home = () => {
  return (
    <div className="home-page">
      <Hero />
      <About />
      <VisionApproach />
      <Expertise />
      <Services />
      <WhyChooseUs />
      <HowWeWork />
      <HomeReviews />
      <TrustedBy />
      <Contact />
    </div>
  );
};

export default Home;
